import {SingleZoneDetailsTableApp} from "../Funtionality/SingleZoneDetailsTableApp";
import Subtitle from "../../../../components/Header/Subtitle";
import {permissionObj} from "../../../../Helpers/permission";
import ButtonSubAction from "../../../../components/buttons/ButtonSubAction";
import {AddIcon, TrashOutlineIcon} from "../../../../components/buttons/IconButtons";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import CustomTable from "../../../../components/table/CustomTable";
import React from "react";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const SubZonesDetailsTable = ({
    zoneDetailFatherAndChild,
    setSelectSubZoneForDelete,
    setModalShow,
    setIsFatherZone,
    selectSubZoneForDelete,
    setDeleteShowSubZone,
    isAllCheckedSubZone,
    setIsAllCheckedSubZone,
    disabled=false,
    table=false,
    tableId,
    searchId,
    modified,
    setModified
}) => {


    const {
        DEV,
        permission,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
        pagination,
        deletePermission
    } = SingleZoneDetailsTableApp({
        data:zoneDetailFatherAndChild,
        selectedList:selectSubZoneForDelete,
        setSelectedList: setSelectSubZoneForDelete,
        setIsAllChecked: setIsAllCheckedSubZone,
        disabled,
        tableId,
        modified,
        setModified
    });
    return (
        <>
            <Subtitle
                table={table}
                name={'internal_monitoring'}
                divStack={
                    <>
                        {(!disabled &&
                            (DEV || permission?.includes(permissionObj?.WEB_ZONE_CREATE))) && (
                            <ButtonSubAction
                                id='btn_szd_add_sub_zone'
                                name='create_subzone'
                                Icon={AddIcon}
                                onClick={()=>{
                                    setModalShow(true);
                                    setIsFatherZone({
                                        id: zoneDetailFatherAndChild?.id,
                                        name: zoneDetailFatherAndChild?.name,
                                    });
                                }}
                            />
                        )}
                    </>
                }
            >
                {
                   ( (!disabled && (DEV ||
                    permission?.includes(permissionObj?.WEB_ZONE_DELETE))) &&
                    zoneDetailFatherAndChild?.children?.length > 0) && (
                        <ButtonAction
                            id='btn_szd_delete'
                            name='delete'
                            className='btn-icon-delete'
                            disabled={selectSubZoneForDelete?.length === 0}
                            Icon={TrashOutlineIcon}
                            onClick={() => setDeleteShowSubZone(true)}
                            splitName={false}
                        />
                    )}
            </Subtitle>
               <CustomTable tableId={tableId}
                            searchId={searchId}
                            checkbox={deletePermission}
                            checkboxTitle={"de_/_select_all"}
                            isAllChecked={isAllCheckedSubZone}
                            onChangeCheckbox={handleDeleteAll}
                            thead={thead}
                            tbody={tbody}
                            columnActions={false}
                            getActionsButtons={getActionsButtons}
                            handleCheckboxChange={handleCheckboxChange}
                            selectedList={selectSubZoneForDelete}
                            withoutHeight={true}

               />
            { !disabled &&
                pagination()
            }
        </>
    )
}

export default SubZonesDetailsTable
